import { z, ZodType } from 'zod'

import { TripAddress } from '../../../lib/types/models/trip-address/trip-address'
import { TripAddressInput } from '../../../lib/types/models/trip-address/trip-address-input'
import { FILE_VALIDATION } from '../../../lib/utils/validations/file.validation'
import { createStringSchema } from '../../../lib/utils/validations/string-validation'

export const tripAddressSchema: ZodType<TripAddressInput> = z.object({
  label: createStringSchema('Titre'),
  adresseURI: createStringSchema("URL de l'adresse").url('Veuillez entrer une URL valide'),
  address1: createStringSchema('Adresse'),
  address2: createStringSchema("Complément d'adresse", { nullish: true }),
  city: createStringSchema('Ville'),
  zipCode: createStringSchema('Code postal'),
  country: createStringSchema('Pays'),
  comments: createStringSchema('Commentaires', { nullish: true }),
  pictures: z
    .array(FILE_VALIDATION(), {
      required_error: 'Veuillez télécharger au moins un fichier',
      invalid_type_error: 'Veuillez télécharger un fichier valide'
    })
    .default([])
})

export const mapTripAddressToInput = (tripAddress: TripAddress): TripAddressInput => {
  return {
    label: tripAddress.label,
    adresseURI: tripAddress.adresseURI,
    address1: tripAddress.address1,
    address2: tripAddress.address2,
    city: tripAddress.city,
    zipCode: tripAddress.zipCode,
    country: tripAddress.country,
    comments: tripAddress.comments,
    pictures: tripAddress.pictures
  }
}
